import { useMemo } from 'react';
import { useRouteParams } from './useRouteParams';
import { AsyncComponentHookResult } from '../../../Types/ComponentHookResult';
import { useFinancialPlanQuery } from '../../api/useFinancialPlanQuery';
import { GoalDTO } from '../../types/goalsDTO';

interface UseGoalParams {
  goalId?: string;
}

export const useGoal = ({
  goalId: _goalId,
}: UseGoalParams = {}): AsyncComponentHookResult<GoalDTO> => {
  const queryResult = useFinancialPlanQuery();

  const { goalId: routeGoalId } = useRouteParams();

  const goalId = _goalId ?? routeGoalId;

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const { Goals: goals } = queryResult.data;

    const goal = goals.find(({ GoalId }) => GoalId === goalId);

    return goal || null;
  }, [goalId, queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
